import React, { useState } from 'react';
import DatePicker from 'react-datepicker/es';
import axios from 'axios';

const MarketArchiveStockValue = ({ symbol }) => {

  const TODAY = new Date();
  const MIN_DATE = new Date('2005-01-01');

  const [priceDate, setPriceDate] = useState(TODAY);
  const [priceData, setPriceData] = useState(undefined);
  const [priceErrorMsg, setPriceErrorMsg] = useState('');

  const [documentFromDate, setDocumentFromDate] = useState(TODAY);
  const [documentToDate, setDocumentToDate] = useState(TODAY);

  function getPriceData(date) {
    const language = drupalSettings.path.currentLanguage || '';
    const query = `/` + language + `/api/market/${symbol}/day?date=${date}`;

    axios
      .get(query)
      .catch(error => {
        setPriceErrorMsg(Drupal.t('No data'));
      })
      .then(resp => {
        if (resp && resp.status === 200) {
          setPriceData(resp.data);
        } else {
          setPriceData(undefined);
          setPriceErrorMsg(Drupal.t('No data'));
        }
      });
  }

  function isWeekday(date) {
    const day = (new Date(date)).getDay();
    return day !== 0 && day !== 6;
  }

  return (
    <>
      <form className="calculators">
        <div
          className="date form-group form--select-wrapper form-date-select">
          <label>{Drupal.t('Select date')}:</label>
            <DatePicker
              selected={priceDate}
              maxDate={TODAY}
              minDate={MIN_DATE}
              onChange={dateFromPicker => setPriceDate(dateFromPicker)}
              className="form-control"
              dateFormat="dd-MM-yyyy"
              filterDate={isWeekday}
            />
            <i className="fa fa-calendar"></i>
        </div>

        <div className="text-right">
        <span
          className="mt-1 errorMsg badge badge-danger">{priceErrorMsg}</span>
        </div>

        <div className="price-button form-group">
          <input type="button"
                 value={Drupal.t('Show quote', {}, { context: 'Stock' })}
                 className="w-100 btn btn-calculator"
                 onClick={() => {
                   setPriceErrorMsg('');
                   getPriceData(formatDate(priceDate));
                 }}/>
        </div>

        <div className="archive-calculator">
          <div
            className="price-open-close form-group form--input-wrapper input-inactive">
            <label
              className="">{Drupal.t('Open', {}, { context: 'Stock' })}:</label>
            <input className="form-control text-right price-open" type="text"
                   disabled
                   value={priceData ? priceData.price_open : '-'}/>
          </div>
          <div
            className="price-open-close form-group form--input-wrapper input-inactive">
            <label
              className="">{Drupal.t('Close', {}, { context: 'Stock' })}:</label>
            <input className="form-control text-right price-close" type="text"
                   disabled
                   value={priceData ? priceData.price_close : '-'}/>
          </div>


          <div
            className="price-open-close form-group form--input-wrapper input-inactive">
            <label
              className="">{Drupal.t('High', {}, { context: 'Stock' })}:</label>
            <input className="form-control text-right price-high" type="text"
                   disabled
                   value={priceData ? priceData.price_high : '-'}/>
          </div>

          <div
            className="price-open-close form-group form--input-wrapper input-inactive">
            <label
              className="">{Drupal.t('Low', {}, { context: 'Stock' })}:</label>
            <input className="form-control text-right price-low" type="text"
                   disabled
                   value={priceData ? priceData.price_low : '-'}/>
          </div>
        </div>

        <div
          className="volume form-group form--input-wrapper input-inactive col-12">
          <label
            className="">{Drupal.t('Volume', {}, { context: 'Stock' })}:</label>
          <input className="form-control text-right price-low" type="text"
                 disabled
                 value={priceData ? priceData.volume : '-'}/>

        </div>

        <div className="d-flex flex-nowrap">
          <div className="col-6 date form-group form--select-wrapper form-date-select">
            <label>{Drupal.t('From')}:</label>
              <DatePicker
                selected={documentFromDate}
                maxDate={TODAY}
                minDate={MIN_DATE}
                onChange={dateFromPicker => setDocumentFromDate(dateFromPicker)}
                className="form-control"
                dateFormat="dd-MM-yyyy"
              />
              <span className="datepicker-icons pull-right">
            <i className="fa fa-calendar"></i>
              </span>

          </div>

          <div className="col-6 date form-group form--select-wrapper form-date-select">
            <label>{Drupal.t('To')}:</label>
              <DatePicker
                selected={documentToDate}
                maxDate={TODAY}
                minDate={MIN_DATE}
                onChange={dateFromPicker => setDocumentToDate(dateFromPicker)}
                className="form-control"
                dateFormat="dd-MM-yyyy"
                filterDate={isWeekday}
              />
              <span className="datepicker-icons pull-right">
            <i className="fa fa-calendar"></i>
              </span>
          </div>
        </div>
        <div className="calculate form-group w-100">
          <a
            href={`/market/download/${symbol}/${formatDate(documentFromDate)}/${formatDate(documentToDate)}`}
            className="btn btn-calculator w-100">
            {Drupal.t('Download', {}, { context: 'Stock' })}
          </a>
        </div>
      </form>
    </>
  )
    ;
};

// return date in YYYY-MM-DD format
function formatDate(date) {
  var d = new Date(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) {
    month = '0' + month;
  }
  if (day.length < 2) {
    day = '0' + day;
  }

  return [year, month, day].join('-');
}

export default MarketArchiveStockValue;
